var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "codeblock-tabbed" }, [
    _c("div", [
      _c(
        "div",
        { staticClass: "tabs", attrs: { role: "tablist" } },
        _vm._l(_vm.tabNames, function (tabName) {
          return _c(
            "button",
            {
              key: tabName,
              staticClass: "tab",
              attrs: {
                type: "button",
                role: "tab",
                "aria-controls": tabName,
                "aria-selected": _vm.selected == tabName,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return (() => _vm.select(tabName)).apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(tabName) + "\n      ")]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: _vm.selected } }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }